
export enum RateRequestTypeCd {
	INVOICE = 'Invoice',
	MANUAL = 'Manual',
	PREVIEW = 'Preview',
	RATE_PASS = 'RatePass',
	RATE_QUOTE = 'RateQuote'}

